import React, { useState } from 'react'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-hot-toast'
import { apiService } from '../services/api'

const AdminPage: React.FC = () => {
  const [apiKey, setApiKey] = useState('')
  const [showApiKey, setShowApiKey] = useState(false)

  const updateApiKeyMutation = useMutation({
    mutationFn: apiService.updateApiKey,
    onSuccess: () => { toast.success('API key updated'); setApiKey('') },
    onError: (e: any) => toast.error(e.response?.data?.detail || 'Failed to update API key'),
  })

  const exportMutation = useMutation({
    mutationFn: apiService.exportDatabase,
    onSuccess: (blob) => {
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      const ts = new Date().toISOString().slice(0, 19).replace(/[:-]/g, '').replace('T', '_')
      link.download = `splitscan_backup_${ts}.db`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
      toast.success('Database exported')
    },
    onError: (e: any) => toast.error(e.response?.data?.detail || 'Failed to export database'),
  })

  const updateKey = () => {
    if (!apiKey.trim()) { toast.error('Please enter an API key'); return }
    if (!apiKey.startsWith('sk-')) { toast.error('API key must start with "sk-"'); return }
    updateApiKeyMutation.mutate(apiKey.trim())
  }

  return (
    <>
      <h2 className="page">Settings</h2>
      <p className="sub">API key and database backup.</p>

      <div className="glass-card" style={{ marginBottom: 16 }}>
        <div className="section-title" style={{ marginTop: 0 }}>Anthropic API key</div>
        <p className="tiny muted" style={{ marginBottom: 4 }}>
          Used for reading receipt photos with Claude. Stored securely and persists across restarts.
        </p>
        <div className="field">
          <label>New API key</label>
          <div style={{ position: 'relative' }}>
            <input
              type={showApiKey ? 'text' : 'password'}
              placeholder="sk-ant-api03-…"
              value={apiKey}
              onChange={(e) => setApiKey(e.target.value)}
            />
            <button
              type="button"
              className="btn-sm"
              style={{ position: 'absolute', right: 6, top: 6 }}
              onClick={() => setShowApiKey(!showApiKey)}
            >
              {showApiKey ? 'Hide' : 'Show'}
            </button>
          </div>
        </div>
        <button className="cta" style={{ width: '100%', justifyContent: 'center', marginTop: 16 }} disabled={updateApiKeyMutation.isLoading || !apiKey.trim()} onClick={updateKey}>
          {updateApiKeyMutation.isLoading ? 'Updating…' : 'Update API key'}
        </button>
      </div>

      <div className="glass-card">
        <div className="section-title" style={{ marginTop: 0 }}>Database export</div>
        <p className="tiny muted" style={{ marginBottom: 4 }}>
          Download a backup of all receipt and payment data (without images).
        </p>
        <button className="cta ghost" style={{ width: '100%', justifyContent: 'center', marginTop: 12 }} disabled={exportMutation.isLoading} onClick={() => exportMutation.mutate()}>
          {exportMutation.isLoading ? 'Exporting…' : 'Download database'}
        </button>
      </div>
    </>
  )
}

export default AdminPage
